const filterConfig = {
  type: 'object',
  properties: {
        // customer_id: { 
        //     type: 'integer', 
        // },
        // report_id: { 
        //     type: 'integer', 
        // },
        // El selector devuelve customers.id, no invoice_accounts.id (son secuencias
        // distintas), por eso el filtro es receiver_customer_id y no receiver_account_id.
        receiver_customer_id: {
          type: 'integer',
        },
        start_date: {
          type: "string",
          format: "date",
        },
        end_date: {
          type: "string",
          format: "date",
        },
        search: {
            type: 'string',
        },
    }
}
const getFiltersConfig: any = (type: string) => {
  return filterConfig;
}
export default getFiltersConfig;